import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Toaster } from '@/components/ui/sonner';
import CookieConsent from '@/components/CookieConsent';

// Pages
import HomePage from '@/pages/HomePage';
import UniversitiesPage from '@/pages/UniversitiesPage';
import UniversityDetailPage from '@/pages/UniversityDetailPage';
import CoursesPage from '@/pages/CoursesPage';
import StudyUSAPage from '@/pages/StudyUSAPage';
import StudyEuropePage from '@/pages/StudyEuropePage';
import ScholarshipsPage from '@/pages/ScholarshipsPage';
import SkillsPage from '@/pages/SkillsPage';
import RankingsPage from '@/pages/RankingsPage';
import BlogPage from '@/pages/BlogPage';
import BlogPostPage from '@/pages/BlogPostPage';
import SearchPage from '@/pages/SearchPage';
import AdminPage from '@/pages/AdminPage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';
import AdvertisePage from '@/pages/AdvertisePage';
import SubmitGuestPostPage from '@/pages/SubmitGuestPostPage';
import PrivacyPage from '@/pages/PrivacyPage';
import TermsPage from '@/pages/TermsPage';
import AffiliateDisclosurePage from '@/pages/AffiliateDisclosurePage';
import Top10USA2026Page from '@/pages/Top10USA2026Page';
import IvyLeagueVsRussellGroupPage from '@/pages/IvyLeagueVsRussellGroupPage';

function App() {
  return (
    <BrowserRouter>
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/universities" element={<UniversitiesPage />} />
            <Route path="/universities/:id" element={<UniversityDetailPage />} />
            <Route path="/courses" element={<CoursesPage />} />
            <Route path="/study-usa" element={<StudyUSAPage />} />
            <Route path="/study-europe" element={<StudyEuropePage />} />
            <Route path="/scholarships" element={<ScholarshipsPage />} />
            <Route path="/skills" element={<SkillsPage />} />
            <Route path="/rankings" element={<RankingsPage />} />
            <Route path="/rankings/top-10-usa-2026" element={<Top10USA2026Page />} />
            <Route path="/rankings/ivy-league-vs-russell-group" element={<IvyLeagueVsRussellGroupPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/advertise" element={<AdvertisePage />} />
            <Route path="/submit-guest-post" element={<SubmitGuestPostPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/affiliate-disclosure" element={<AffiliateDisclosurePage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-right" />
        <CookieConsent />
      </div>
    </BrowserRouter>
  );
}

export default App;